<div class="instruction" tabindex="0" (click)="openLink()" (keydown.enter)="openLink()" (keydown.space)="openLink()">
    {{ linkTranslationKey() | translate }}
    <warema-icon-button aria-hidden="true" icon="play" tabindex="-1" />
</div>
